import { render, staticRenderFns } from "./addParticipantFiliation.vue?vue&type=template&id=39e718f4&scoped=true"
import script from "./addParticipantFiliation.vue?vue&type=script&lang=js"
export * from "./addParticipantFiliation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39e718f4",
  null
  
)

export default component.exports